const componentLibrary = {};

componentLibrary["LoginScreen"] = require("./LoginScreen/LoginScreen").default;
componentLibrary["SlideShow"] = require("./SlideShow/SlideShow").default;

export default componentLibrary;
